function state() {
  return {
    policy: {},
    policies: [],
    policiesMeta: {},
    partners: [],
    productCategories: [],
  };
}

export default state;
